import React, { useState } from 'react';
import professionalVideoCover from '../../../assets/images/home/professional_video_cover.png';

const ProfessionalSection = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayClick = () => {
        setIsPlaying(true);
    };

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Developed by <span className="text-primary">Professionals</span>
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Developed by professionals to deliver quality, expertise, and drive knowledge and productivity through Nexgen Learning
                    </p>
                </div>

                <div className="relative max-w-4xl mx-auto">
                    {/* Video Container */}
                    <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl">
                        <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-purple-500/20 z-10"></div>

                        {!isPlaying ? (
                            <div className="relative w-full h-full cursor-pointer group">
                                <img
                                    src={professionalVideoCover}
                                    alt="Professional Video Cover"
                                    className="w-full h-full object-cover"
                                />
                                {/* Play Button Overlay */}
                                <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-all duration-300">
                                    <div className="w-20 h-20 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white transition-all duration-300 cursor-pointer z-20" onClick={handlePlayClick}>
                                        <div className="w-0 h-0 border-t-[15px] border-t-transparent border-l-[25px] border-l-primary border-b-[15px] border-b-transparent ml-1 group-hover:scale-110 transition-transform duration-300"></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <iframe
                                className="w-full h-full"
                                src="https://player.vimeo.com/video/1059134376?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1&h=7b6af30cb1#t="
                                title="Nexgen Learning Professional Development"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProfessionalSection; 